/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

const styles = {
  card: css`
    display: flex;
    padding: var(--cds-spacing-300);
    flex-direction: column;
    align-items: flex-start;
    gap: var(--cds-spacing-200);
    border-radius: var(--cds-spacing-100);
    border: 2px solid var(--neutral-background-primary-weak, #f5f7f8);
    background: var(--neutral-background-primary-weak, #f5f7f8);
  `,
};

const NoCoursesCard: React.VFC<{ description?: string }> = ({ description = _t('No courses added') }) => {
  return (
    <div css={styles.card}>
      <Typography2 component="p" variant="bodyPrimary">
        {description}
      </Typography2>
    </div>
  );
};

export default NoCoursesCard;
